import { useState } from "react";
import { ApiError } from "./api";

export function uploadErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.status === 401) {
      return "A munkamenet lejárt — jelentkezzen be újra, és próbálja újra a feltöltést.";
    }
    const body = err.body;
    const detail =
      body && typeof body === "object" && "message" in body
        ? String((body as { message: unknown }).message)
        : err.message;
    return `Feltöltési hiba: ${detail}`;
  }
  if (err instanceof Error) {
    return `Feltöltési hiba: ${err.message}`;
  }
  return "Ismeretlen hiba a feltöltés során.";
}

/** Shared upload state + runner. */
export function useUpload() {
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  async function run(fn: () => Promise<void>) {
    setUploading(true);
    setUploadError(null);
    setUploadSuccess(false);
    try {
      await fn();
      setUploadSuccess(true);
      setTimeout(() => setUploadSuccess(false), 3000);
    } catch (err) {
      console.error("Upload error:", err);
      setUploadError(uploadErrorMessage(err));
    } finally {
      setUploading(false);
    }
  }

  return { uploading, uploadError, uploadSuccess, run };
}
